export default {
    content: null,
    ctx: null,
    color: {
        black: '#111111',
        backgroundColor: '#e6e6e6',
        white: "#ffffff",
        red: "#c1272d",
        lightBlue: "#128fb8",
        gray: "#9b99a1",
    },
    size: {
        top: 2,
        left: 20,
        span_height: 30,
        span_width: 30,
        child_left: 140,
        grand_child_left: 380,
        border_start_span: 40,
        border_start_append_span: 140,
    },
    lineWidth: 2,
    retina: 2,

    init: function(id) {
        this.content = document.querySelector(id);
        this.ctx = this.content.getContext('2d');
    },

    draw: function(family) {
        this._draw(family, false);
        this._draw(family, true);
    },

    base64: function() {
        return this.content.toDataURL('image/png');
    },

    _draw: function(family, isWriteMode) {
        if (family.parent.length > 0) {
            this._drawParent(family, isWriteMode);
        } else if (family.brother.length > 0) {
            this._drawBrother(family, isWriteMode);
        } else {
            this._drawChild(family, isWriteMode);
        }
    },

    _drawParent: function(family, isWriteMode) {
        let parent = JSON.parse(JSON.stringify(family.parent[0]));
        if (parent.grand_parent.length > 0) {
            if (!parent.exist) {
                parent.grand_parent[0].exist = true;
                parent.grand_parent[1].exist = true;
            }
            this.drawBox(20, 20, parent.grand_parent[0], 2, isWriteMode);
            this.drawBox(20, 140, parent.grand_parent[1], 2, isWriteMode);
            this.drawLine(70 * this.retina, 82 * this.retina, 70 * this.retina, 140 * this.retina, isWriteMode);
            this.drawLine(70 * this.retina, 110 * this.retina, 150 * this.retina, 110 * this.retina, isWriteMode);
        }
        parent = JSON.parse(JSON.stringify(family.parent[1]));
        if (parent.grand_parent.length > 0) {
            if (!parent.exist) {
                parent.grand_parent[0].exist = true;
                parent.grand_parent[1].exist = true;
            }
            this.drawBox(20, 240, parent.grand_parent[0], 2, isWriteMode);
            this.drawBox(20, 380, parent.grand_parent[1], 2, isWriteMode);
            this.drawLine(70 * this.retina, 302 * this.retina, 70 * this.retina, 380 * this.retina, isWriteMode);
            this.drawLine(70 * this.retina, 340 * this.retina, 150 * this.retina, 340 * this.retina, isWriteMode);
        }

        this.drawBox(150, 80, family.parent[0], 2, isWriteMode);
        this.drawBox(150, 310, family.parent[1], 2, isWriteMode);

        this.drawBox(300, 180, family, family.mode, isWriteMode);

        this.drawLine(200 * this.retina, 142 * this.retina, 200 * this.retina, 310 * this.retina, isWriteMode);
        this.drawLine(200 * this.retina, 230 * this.retina, 300 * this.retina, 230 * this.retina, isWriteMode);

        if (family.spouse.length > 0) {
            this.drawBox(340, 340, family.spouse[0], 2, isWriteMode);
            this.drawLine(390 * this.retina, 270 * this.retina, 390 * this.retina, 340 * this.retina, isWriteMode);
        }

        if (!isWriteMode) {
            this.setSize(500 * this.retina, 500 * this.retina);
        }
    },

    _drawChild: function(family, isWriteMode) {
        // 高さ・幅計算
        let h = this.size.top;
        let w = this.size.left;
        let maxWidths = {
            family: 0,
            child: 0,
            grandChild: 0,
            setFamily: function (w) {
                if (w > this.family) {
                    this.family = w;
                }
            },
            setChild: function (w) {
                if (w > this.child) {
                    this.child = w;
                }
            },
            setGrandChild: function (w) {
                if (w > this.grandChild) {
                    this.grandChild = w;
                }
            },
            getWidth: function() {
                return this.family + this.child + this.grandChild;
            }
        };

        let childBefTop = 0;
        let befSpouseSize = {};
        const familySize = this.drawBox(this.size.left, h, family, family.mode, isWriteMode);
        // h += familySize.height + this.size.span_height;
        h += familySize.height / this.retina + this.size.span_height;
        maxWidths.setFamily(familySize.width + this.size.span_width);
        for (let i = 0, len = family.spouse.length; i < len; i ++) {
            const spouse = family.spouse[i];
            // 子供
            for (let j = 0, lenJ = spouse.children.length; j < lenJ; j ++) {
                const ret = this.drawChild(spouse.children[j], h, childBefTop, maxWidths, familySize, i, j, isWriteMode);
                h = ret.h
                childBefTop = ret.childBefTop
                maxWidths = ret.maxWidths
            }
            // 前の配偶者は常にグレーとする
            let spouseData = JSON.parse(JSON.stringify(spouse));
            if (i > 0) {
                spouseData.exist = true;
            }
            const size = this.drawBox(this.size.left, h, spouseData, 2, isWriteMode);
            h += size.height / this.retina + this.size.span_height;
            maxWidths.setFamily(size.width + this.size.span_width);
            if (i === 0) {
                this.drawLine(
                    familySize.left + this.size.border_start_span,
                    familySize.top + familySize.height,
                    familySize.left + this.size.border_start_span,
                    size.top,
                    isWriteMode
                );
            } else {
                this.drawLine(
                    familySize.left - 20,
                    90,
                    size.left,
                    90,
                    isWriteMode
                );
                this.drawLine(
                    familySize.left - 20,
                    90,
                    familySize.left - 20,
                    size.top + befSpouseSize.height / 2,
                    isWriteMode
                );
                this.drawLine(
                    familySize.left - 20,
                    size.top + (size.height / 2),
                    size.left,
                    size.top + (size.height / 2),
                    isWriteMode
                );
            }
            befSpouseSize = size;
        }
        if (!isWriteMode) {
            this.setSize(500 * this.retina, h * this.retina);
        }
    },

    _drawBrother: function(family, isWriteMode) {
        // 高さ・幅計算
        let h = this.size.top;
        let w = this.size.left;
        let maxWidths = {
            family: 0,
            child: 0,
            grandChild: 0,
            setFamily: function (w) {
                if (w > this.family) {
                    this.family = w;
                }
            },
            setChild: function (w) {
                if (w > this.child) {
                    this.child = w;
                }
            },
            setGrandChild: function (w) {
                if (w > this.grandChild) {
                    this.grandChild = w;
                }
            },
            getWidth: function() {
                return this.family + this.child + this.grandChild;
            }
        };

        let childBefTop = 0
        const familySize = this.drawBox(this.size.left, h, family, family.mode, isWriteMode);
        h += familySize.height / this.retina + this.size.span_height;
        maxWidths.setFamily(familySize.width + this.size.span_width);
        // 兄弟・甥姪
        for (let i = 0, len = family.brother.length; i < len; i ++) {
            const brother = family.brother[i];
            // 子供
            const ret = this.drawBrother(brother, h, childBefTop, maxWidths, familySize, i, isWriteMode);
            h = ret.h
            childBefTop = ret.childBefTop
            maxWidths = ret.maxWidths
        }
        for (let i = 0, len = family.spouse.length; i < len; i ++) {
            const spouse = family.spouse[i];
            const size = this.drawBox(this.size.left, h, spouse, 2, isWriteMode);
            h += size.height / this.retina + this.size.span_height;
            maxWidths.setFamily(size.width + this.size.span_width);
            if (i === 0) {
                this.drawLine(
                    familySize.left + this.size.border_start_span,
                    familySize.height + 4,
                    familySize.left + this.size.border_start_span,
                    size.top,
                    isWriteMode
                );
            } else {
                this.drawLine(
                    familySize.left,
                    familySize.top + (familySize.height / 2) * this.retina,
                    10,
                    familySize.top + (familySize.height / 2) * this.retina,
                    isWriteMode
                );
                this.drawLine(
                    10 * this.retina,
                    familySize.top + (familySize.height / 2),
                    10 * this.retina,
                    size.top + (size.height / 2),
                    isWriteMode
                );
                this.drawLine(
                    10 * this.retina,
                    size.top + (size.height / 2),
                    size.left * this.retina,
                    size.top + (size.height / 2),
                    isWriteMode
                );
            }
        }
        if (!isWriteMode) {
            this.setSize(500 * this.retina, h * this.retina);
        }
    },

    setSize: function(w, h) {
      this.content.height = h;
      this.content.width = w;
    },

    /**
     * ボックス付きのテキストを描画する
     */
    drawBox: function(x, y, model, mode, isWrite = true) {
        if (mode === 1) {
            this.setFont(26);
            this.ctx.fillStyle = this.color.red;
        } else {
            this.setFont();
            if (model.exist) {
                this.ctx.fillStyle = this.color.gray;
            } else {
                this.ctx.fillStyle = this.color.black;
            }
        }
        const fontSize = this.getFontSize(model.label);
        let w = fontSize.width + (40 * this.retina);
        if (w < 100 * this.retina) {
            w = 100 * this.retina;
        }
        let h = (fontSize.height * 2) + (28 * this.retina);

        x *= this.retina;
        y *= this.retina;

        if (isWrite) {
            if (mode === 1) {
                this.drawsq(x, y, w, h, 10 * this.retina, this.color.lightBlue);
                this.setFont(26);
                this.ctx.fillStyle = this.color.red;
            } else {
                if (model.exist) {
                    this.drawsq(x, y, w, h, 10 * this.retina, this.color.gray);
                } else {
                    this.drawsq(x, y, w, h, 10 * this.retina);
                }
                this.setFont();
                if (model.exist) {
                    this.ctx.fillStyle = this.color.gray;
                } else {
                    this.ctx.fillStyle = this.color.black;
                }
            }
            if (mode === 1) {
                this.drawStringCenter(x, y + 16, w, model.label);
                this.setFont(12);
                this.drawStringCenter(x, y + fontSize.height + (26 * this.retina), w, model.comment);
            } else {
                this.drawStringCenter(x, y + 10, w, model.label);
                this.setFont(10);
                this.drawStringCenter(x, y + fontSize.height + (20 * this.retina), w, model.comment);
            }
        }

        return {
            left: x,
            top: y,
            width: w,
            height: h,
        }
    },

    drawLine: function(x1, y1, x2, y2, isWriteMode) {
        if (!isWriteMode) {
            return;
        }
        this.ctx.beginPath();
        this.ctx.moveTo(x1, y1) ;
        this.ctx.lineTo(x2, y2);
        this.ctx.strokeStyle = this.color.black;
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.stroke();
    },

    /**
     * フォントを指定する
     */
    setFont: function(fontSize = 14, fontFamily = 'Arial') {
        this.ctx.font = (fontSize * this.retina) + 'pt ' + fontFamily;
    },

    /**
     * 渡された文字列の高さ、幅を取得する
     */
    getFontSize: function(value) {
        const textSize = this.ctx.measureText(value);
        return {
            width: textSize.width,
            height: textSize.fontBoundingBoxAscent,
        };
    },

    /**
     * 文字描画
     */
    drawString: function(x, y, str) {
        const textSize = this.getFontSize(str);
        this.ctx.fillText(str, x, y + textSize.height);
    },

    /**
     * センタリングで文字を描画する
     */
    drawStringCenter: function(x, y, width, str) {
        const textSize = this.getFontSize(str);
        const w = ((width / 2) - (textSize.width / 2));
        this.drawString(w + x, y, str);
    },

    // 角丸の四角を描画する
    drawsq: function (x, y, w, h, r, color = null) {
        if (!color) {
            color = this.color.black;
        }
        this.ctx.beginPath();
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.strokeStyle = color;
        this.ctx.fillStyle = color;
        this.ctx.moveTo(x,y + r);
        this.ctx.arc(x+r,y+h-r,r,Math.PI,Math.PI*0.5,true);
        this.ctx.arc(x+w-r,y+h-r,r,Math.PI*0.5,0,1);
        this.ctx.arc(x+w-r,y+r,r,0,Math.PI*1.5,1);
        this.ctx.arc(x+r,y+r,r,Math.PI*1.5,Math.PI,1);
        this.ctx.closePath();
        this.ctx.stroke();
        this.ctx.fillStyle = this.color.white;
        this.ctx.fill();
    },

    drawChild: function(child, h, childBefTop, maxWidths, familySize, i, j, isWriteMode) {
        const childSize = this.drawBox(this.size.left + this.size.child_left, h, child, 2, isWriteMode);
        h += childSize.height / this.retina + this.size.span_height;
        maxWidths.setChild(childSize.width + this.size.left + this.size.child_left);
        // 孫
        let grandChildBefTop = 0
        for (let k = 0, lenK = child.grand_child.length; k < lenK; k ++) {
            const grandChild = JSON.parse(JSON.stringify(child.grand_child[k]));
            if (!child.exist) {
                grandChild.exist = true;
            }
            const ret = this.drawGrandChild(grandChild, h, grandChildBefTop, maxWidths, childSize, k, isWriteMode);
            h = ret.h
            grandChildBefTop = ret.grandChildBefTop
            maxWidths = ret.maxWidths
        }
        if (j === 0) {
            childBefTop = childSize.top + (childSize.height / 2)
            if (i === 0) {
                this.drawLine(
                    familySize.left + this.size.border_start_span,
                    childBefTop,
                    childSize.left,
                    childBefTop,
                    isWriteMode
                );
            } else {
                this.drawLine(
                    familySize.left - 20,
                    childBefTop,
                    childSize.left,
                    childBefTop,
                    isWriteMode
                );
            }
        } else {
            this.drawLine(
                ((this.size.child_left - (familySize.left)) / 2) + familySize.left + this.size.border_start_span,
                childBefTop,
                ((this.size.child_left - (familySize.left)) / 2) + familySize.left + this.size.border_start_span,
                childSize.top + (childSize.height / 2),
                isWriteMode
            );
            this.drawLine(
                ((this.size.child_left - (familySize.left)) / 2) + familySize.left + this.size.border_start_span,
                childSize.top + (childSize.height / 2),
                childSize.left,
                childSize.top + (childSize.height / 2),
                isWriteMode
            );
            childBefTop = childSize.top + (childSize.height / 2)
        }

        return {h: h, childBefTop: childBefTop, maxWidths: maxWidths};
    },

    drawGrandChild: function (grandChild, h, grandChildBefTop, maxWidths, childSize, k, isWriteMode) {
        const grandChildSize = this.drawBox(this.size.left + (this.size.child_left * 2), h, grandChild, 2, isWriteMode);
        h += grandChildSize.height / this.retina + this.size.span_height;
        maxWidths.setGrandChild(grandChildSize.width + this.size.left);
        if (k === 0) {
            grandChildBefTop = grandChildSize.top + (grandChildSize.height / 2)
            this.drawLine(
                childSize.left + this.size.border_start_span + this.size.child_left / 2,
                childSize.top + childSize.height,
                childSize.left + this.size.border_start_span + this.size.child_left / 2,
                grandChildBefTop,
                isWriteMode
            );
            this.drawLine(
                childSize.left + this.size.border_start_span + this.size.child_left / 2,
                grandChildBefTop,
                grandChildSize.left,
                grandChildBefTop,
                isWriteMode
            );
        } else {
            this.drawLine(
                childSize.left + this.size.border_start_span + (this.size.child_left),
                grandChildBefTop,
                childSize.left + this.size.border_start_span + (this.size.child_left),
                grandChildSize.top + (grandChildSize.height / 2),
                isWriteMode
            );
            this.drawLine(
                childSize.left + this.size.border_start_span + (this.size.child_left),
                grandChildSize.top + (grandChildSize.height / 2),
                grandChildSize.left,
                grandChildSize.top + (grandChildSize.height / 2),
                isWriteMode
            );
            grandChildBefTop = grandChildSize.top + (grandChildSize.height / 2)
        }

        return {h: h, grandChildBefTop: grandChildBefTop, maxWidths: maxWidths};
    },

    drawBrother: function(child, h, childBefTop, maxWidths, familySize, i, isWriteMode) {
        const childSize = this.drawBox(this.size.left + this.size.child_left, h, child, 2, isWriteMode);
        h += childSize.height / this.retina + this.size.span_height;
        maxWidths.setChild(childSize.width + this.size.left + this.size.child_left);
        // 孫
        let grandChildBefTop = 0
        for (let k = 0, lenK = child.grand_child.length; k < lenK; k ++) {
            const grandChild = JSON.parse(JSON.stringify(child.grand_child[k]));
            if (!child.exist) {
                grandChild.exist = true;
            }
            const ret = this.drawGrandChild(grandChild, h, grandChildBefTop, maxWidths, childSize, k, isWriteMode);
            h = ret.h
            grandChildBefTop = ret.grandChildBefTop
            maxWidths = ret.maxWidths
        }
        // if (j === 0) {
        if (i === 0) {
            this.drawLine(
                familySize.left + this.size.border_start_span + this.size.border_start_append_span,
                childSize.top + (childSize.height / 2) - childSize.height + 2,
                familySize.left + this.size.border_start_span + this.size.border_start_append_span,
                childSize.top + (childSize.height / 2),
                isWriteMode
            );
        } else {
            this.drawLine(
                familySize.left + this.size.border_start_span + this.size.border_start_append_span,
                childBefTop,
                familySize.left + this.size.border_start_span + this.size.border_start_append_span,
                childSize.top + (childSize.height / 2),
                isWriteMode
            );
        }
        childBefTop = childSize.top + (childSize.height / 2);
        this.drawLine(
            familySize.left + this.size.border_start_span + this.size.border_start_append_span,
            childBefTop,
            childSize.left,
            childBefTop,
            isWriteMode
        );

        return {h: h, childBefTop: childBefTop, maxWidths: maxWidths};
    },
};